module.exports = __webpack_public_path__ + "img/framenew_box02.ff714fa4.jpg";